import { stopEvent } from '@aytm/lib/common/func'

export const toggleCheckbox = (event, callback) => {
  if (13 == event.keyCode) callback()
}

export const onInputKeyDown = event => {
  if (13 == event.keyCode) stopEvent(event)
}
